module.exports = __webpack_public_path__ + "static/img/female-bg-fr.19dc24de.png";